
import { ScoresState } from "./types";
import { getTestPoints } from "@/utils/level3/points";

export const resetScoresForTest = (testId: string, currentScores: ScoresState): ScoresState => {
  console.log(`resetScoresForTest called for test: ${testId}`);
  
  // Determine if we are in level 2
  const isLevel2 = window.location.pathname.includes('level2');
  
  // Get the points for the test
  let testPoints = getTestPoints(testId);
  
  // For level 2 iron, fairwayWood, and driver tests, use point D
  if (isLevel2 && (testId.includes('iron-') || testId.includes('fairwayWood-') || testId.includes('driver-'))) {
    testPoints = ["D"];
  }
  
  console.log(`resetScoresForTest - points to initialize: ${JSON.stringify(testPoints)}`);
  
  // Create a fresh copy of current scores
  const newScores = { ...currentScores };
  
  // Initialize points for this test
  testPoints.forEach(point => {
    newScores[point] = Array(10).fill(null);
  });
  
  return newScores;
};

export const calculatePointTotal = (point: string, scores: ScoresState): number => {
  const pointScores = scores[point];
  
  console.log(`calculatePointTotal - scores for point ${point}: ${JSON.stringify(pointScores)}`);
  
  if (!pointScores) {
    return 0;
  }
  
  let total = 0;
  
  for (const score of pointScores) {
    if (typeof score === 'number') {
      total += score;
    }
  }
  
  return total;
};

export const calculateGrandTotal = (testId: string, scores: ScoresState): number => {
  // Get points for the test
  let testPoints = getTestPoints(testId);
  
  // Determine if we are in level 2
  const isLevel2 = window.location.pathname.includes('level2');
  
  // For level 2 iron, fairwayWood, and driver tests, use point D
  if (isLevel2 && (testId.includes('iron-') || testId.includes('fairwayWood-') || testId.includes('driver-'))) {
    testPoints = ["D"];
  }
  
  // Pour le niveau 1, utiliser les points corrects depuis le service Level1
  const isLevel1 = window.location.pathname.includes('level1');
  if (isLevel1 && (testId === 'iron-long' || testId === 'iron-mid')) {
    testPoints = ["G"]; // Utiliser seulement le point G pour les tests de fer niveau 1
  }
  
  console.log(`calculateGrandTotal - points to use: ${JSON.stringify(testPoints)}`);
  console.log(`calculateGrandTotal - current scores: ${JSON.stringify(scores)}`);
  
  let grandTotal = 0;
  
  for (const point of testPoints) {
    const pointTotal = calculatePointTotal(point, scores);
    console.log(`calculateGrandTotal - pointTotal for ${point}: ${pointTotal}`);
    grandTotal += pointTotal;
  }
  
  return grandTotal;
};
